module.exports = __webpack_public_path__ + "assets/azurecloud.9ef5d9f9.svg";